// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lNXFe6,.LlfzUK{position:relative}.lNXFe6{display:flex;color:"color(--linkColor)";text-decoration:underline}.lNXFe6.jRv8RQ,.lNXFe6:hover{text-decoration:none}.lNXFe6.dDewfs{display:inline-flex;margin-top:10px}.lNXFe6.AlfdV5{display:none}.kstZSY{width:9px;height:9px;margin-right:4px}.LlfzUK{padding-left:21px}.LlfzUK:before{position:absolute;content:'';width:11px;height:6px;top:6px;left:0;transform:rotate(-45deg);border-left:1px solid "color(--itemDetailsColor)";border-bottom:1px solid "color(--itemDetailsColor)"}.LlfzUK.dDewfs{margin-top:10px;padding-left:25px}.LlfzUK.dDewfs:before{width:14px;height:7px}.XUZqB1{display:inline-block;padding-left:0;padding-right:21px}.XUZqB1:before{left:auto;right:0}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"markCardPrimary": `lNXFe6`,
	"defaultCard": `LlfzUK`,
	"loading": `jRv8RQ`,
	"mobile": `dDewfs`,
	"expired": `AlfdV5`,
	"loader": `kstZSY`,
	"defaultCardRTL": `XUZqB1`,
	"defaultCardRtl": `XUZqB1`
};
export default ___CSS_LOADER_EXPORT___;
